// Centralized names for the auth-related sessionStorage keys and cookies, shared
// across the client (AuthProvider, fetch), middleware (proxy), and API routes so
// a rename only happens in one place.
export const ACCESS_TOKEN_KEY = 'dd_access_token';
export const REFRESH_COOKIE = 'dd_refresh_token';
// Cookie the Kinde SDK sets for a signed-in team member. Used only as a presence
// hint by the proxy; real validation happens in AuthProvider via /me.
export const KINDE_ACCESS_COOKIE = 'access_token';
export const LAST_SHOPIFY_DOMAIN_KEY = 'dd_last_shopify_domain';
// Per-store Shopify app handle from /me, cached so a failed-refresh bounce can
// send the merchant back through the correct app (stores on custom app
// credentials have their own handle). Falls back to NEXT_PUBLIC_SHOPIFY_APP_HANDLE.
export const LAST_SHOPIFY_APP_HANDLE_KEY = 'dd_last_shopify_app_handle';
